import { useTranslate } from '../../TranslationsContext'
import { useIsBreakpoint } from '../../utils/useBreakpoint'
import { Container } from '../Container/Container'
import { Heading } from '../Heading/Heading'
import './OverFooter.css'

export function OverFooter() {
  const translate = useTranslate()
  const isLargerThan768 = useIsBreakpoint(768)
  const findClosestUrl = translate('OverFooter.findClosest.url')

  return findClosestUrl !== 'OverFooter.findClosest.url' ? (
    <div className="OverFooter">
      <Container>
        {isLargerThan768 ? (
          <Heading type="Section" negative>
            {translate('OverFooter.content.full')}
          </Heading>
        ) : (
          <>
            <p>{translate('OverFooter.content.1')}</p>
            <Heading type="Section" negative>
              {translate('OverFooter.content.2')}
            </Heading>
          </>
        )}
        <p className="findPharmacyLink">
          <a href={findClosestUrl} target="_blank" rel="noreferrer">
            {translate('Cta.findClosest')}
          </a>
        </p>
      </Container>
    </div>
  ) : null
}
